







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';


@Component({
  components: { AdminIframe, PageTitle },
})
export default class AdminAddIframe extends Vue {
  private title = '운영자 계정 등록';

  private get remoteSrc() {
    const query = this.$route.query;
    const queryString = new URLSearchParams({ ...query, serviceType: 'PREMIUM' }).toString();
    return `${process.env.VUE_APP_ADMIN_REMOTE_URL}/configuration/management/add?${queryString}`;
  }
}
